import axios from "axios";

class ZipFilesService {
async getZipFiles(type, slug ='', pageIndex, pageSize = 10) {
  const params = {
    pageIndex,
    pageSize,
  };

  if (type) params.type = type;
  if (slug) params.slug = slug;

  const response = await axios.get("/api/zipfiles", { params });
  return response.data;
}



  async recreateZip(type, id) {
    let url;
    if (type === "item") {
      url = `/api/zipfiles/item/create-zip?itemId=${id}`;
    } else if (type === "category") {
      url = `/api/zipfiles/category/create-zip?categoryId=${id}`;
    } else {
      throw new Error("Invalid type");
    }

    const response = await axios.get(url);
    return response.data;
  }
}

export default new ZipFilesService();
